// Every word "It's Me" shows lives here. Edit freely.
// lyrics: "at" is when a line begins (seconds into the song); "w" is when each word is sung.
// Words are split on spaces; a line without spaces can give "split" (its pieces, in order) to time them.
// If you change the words of a line, its "w" may no longer match: the words are then spread evenly.
window.HANA_TEXT = {
  "title": "It's Me",
  "meaning": "who's your bias?",
  "listen": "watch",
  "loading": "…",
  "again": "again",
  "aria": { "play": "play", "pause": "pause", "seek": "song position", "full": "full screen" },
  "mark": { "hint": "press M on every moment you feel", "count": "marks", "copied": "copied" },

  // the words the world is made of (walls, screens, stickers)
  "wall": ["BIAS", "推し", "IDOL", "ME", "♥", "★"],
  "stage": { "live": "LIVE", "on": "NOW ON STAGE", "rec": "REC" },
  "feed": {
    "handle": "@only.my.bias",
    "account": "fan account",
    "likes": "♥ 99,999",
    "posted": "POSTED",
    "follow": "FOLLOW",
    "seen": "seen",
    "new": "NEW POST"
  },
  "jewel": "宝石箱",
  "sphere": "U ♥ ME",
  // the Sphere spells "U ♥ <name>" for each of them during the couple-initial line; the Hangul runs beneath
  "members": [
    { "en": "YUNAH", "ko": "윤아" },
    { "en": "MINJU", "ko": "민주" },
    { "en": "MOKA", "ko": "모카" },
    { "en": "WONHEE", "ko": "원희" },
    { "en": "IROHA", "ko": "이로하" }
  ],
  "news": { "paper": "THE SCHOOL DAILY", "posters": ["推し", "速報", "号外", "BIAS", "♥"], "head": "IT'S ME" },
  "fave": "FAVE",
  "hud": { "err": "ERR 404", "signal": "NO SIGNAL" },
  // the corridor and the round room are walled with these
  "walls": ["IT'S ME", "IT'S ME", "BIAS"],

  "lyrics": [
    { "at": 2.10, "line": "Who’s your bias?", "w": [2.10, 2.40, 2.60] },
    { "at": 3.00, "line": "I’m your bias!", "w": [3.00, 3.20, 3.40] },
    { "at": 3.68, "line": "Who’s your bias?", "w": [3.68, 3.98, 4.18] },
    { "at": 4.58, "line": "I’m your bias!", "w": [4.58, 4.78, 4.98] },
    { "at": 5.26, "line": "Who’s your bias?", "w": [5.26, 5.56, 5.76] },
    { "at": 6.16, "line": "I’m your bias!", "w": [6.16, 6.36, 6.56] },

    { "at": 14.84, "line": "I’m the one, I’m your idol", "w": [14.84, 15.10, 15.36, 15.66, 15.80, 15.94] },
    { "at": 16.20, "line": "つねにキミいいね", "split": ["つねに", "キミ", "いいね"], "w": [16.20, 16.60, 16.95] },
    { "at": 17.45, "line": "キミはまるで loyal fan", "w": [17.45, 18.66, 19.08] },
    { "at": 21.00, "line": "盗み見 with fan account", "w": [21.00, 21.92, 22.12, 22.42] },
    { "at": 22.92, "line": "僕は欲しい 正直さ", "w": [22.92, 23.58] },
    { "at": 24.38, "line": "止めないでよ 宝石箱", "w": [24.38, 25.56] },
    { "at": 27.66, "line": "Pradaより高価で無二なのに", "split": ["Pradaより", "高価で", "無二なのに"], "w": [27.66, 28.70, 29.60] },
    { "at": 33.98, "line": "よその騒ぎ", "split": ["よその", "騒ぎ"], "w": [33.98, 34.60] },
    { "at": 35.44, "line": "なぜまたそっち", "split": ["なぜ", "また", "そっち"], "w": [35.44, 36.00, 36.60] },

    { "at": 40.60, "line": "Who’s your bias?", "w": [40.60, 40.90, 41.05] },
    { "at": 41.52, "line": "I’m your bias!", "w": [41.52, 41.65, 41.75] },
    { "at": 42.18, "line": "Who’s your bias?", "w": [42.18, 42.48, 42.63] },
    { "at": 43.10, "line": "I’m your bias!", "w": [43.10, 43.23, 43.33] },
    { "at": 43.76, "line": "Who’s your bias?", "w": [43.76, 44.06, 44.21] },
    { "at": 44.68, "line": "I’m your bias!", "w": [44.68, 44.81, 44.91] },
    { "at": 45.34, "line": "Who? Who?", "w": [45.34, 45.74] },
    { "at": 46.92, "line": "Who’s your bias?", "w": [46.92, 47.22, 47.37] },
    { "at": 47.84, "line": "I’m your bias!", "w": [47.84, 47.97, 48.07] },
    { "at": 48.50, "line": "Who’s your bias?", "w": [48.50, 48.92, 49.00] },
    { "at": 49.42, "line": "I’m your bias!", "w": [49.42, 49.55, 49.65] },
    { "at": 50.08, "line": "Who’s your bias?", "w": [50.08, 50.38, 50.53] },
    { "at": 51.00, "line": "I’m your bias!", "w": [51.00, 51.13, 51.23] },
    { "at": 52.46, "line": "It’s Me", "w": [52.46, 53.00] },

    { "at": 55.66, "line": "It’s Me", "w": [55.66, 56.20] },
    { "at": 57.26, "line": "It’s Me", "w": [57.26, 57.60] },
    { "at": 58.76, "line": "Me, Me!", "w": [58.76, 59.28] },
    { "at": 61.98, "line": "It’s Me", "w": [61.98, 62.60] },
    { "at": 63.18, "line": "Hey, just say I’m your fave!", "w": [63.18, 63.70, 64.00, 64.50, 64.80, 65.20] },

    { "at": 66.04, "line": "I yelled キミ, hilarious!", "w": [66.04, 66.32, 66.54, 66.80] },
    { "at": 67.64, "line": "Oh my my my my", "w": [67.64, 67.90, 68.20, 68.50, 68.90] },
    { "at": 69.18, "line": "袖手観 like tortilla", "w": [69.18, 70.00, 70.15] },
    { "at": 70.50, "line": "Why? Why? Why? Why?", "w": [70.50, 71.00, 71.45, 71.90] },
    { "at": 72.50, "line": "This 初恋 ain’t no joke", "w": [72.50, 72.80, 73.14, 73.45, 73.72] },
    { "at": 73.95, "line": "It can’t can’t can’t can’t", "w": [73.95, 74.15, 74.60, 75.00, 75.38] },
    { "at": 75.78, "line": "モヤモヤし! Post me on your gram", "w": [75.78, 76.40, 76.70, 76.94, 77.18, 77.30] },
    { "at": 78.62, "line": "Sphere 電照板に couple initial lettering", "w": [78.62, 79.20, 80.00, 80.45, 81.46] },
    { "at": 85.12, "line": "上げろ 僕らの 学校 大字報へ headline", "w": [85.12, 85.80, 86.50, 87.20, 88.30] },

    { "at": 91.74, "line": "Who’s your bias?", "w": [91.74, 92.14, 92.18] },
    { "at": 92.66, "line": "I’m your bias!", "w": [92.66, 92.80, 92.92] },
    { "at": 93.40, "line": "Who’s your bias?", "w": [93.40, 93.70, 93.78] },
    { "at": 94.22, "line": "I’m your bias!", "w": [94.22, 94.42, 94.54] },
    { "at": 94.98, "line": "Who’s your bias?", "w": [94.98, 95.28, 95.43] },
    { "at": 95.90, "line": "I’m your bias!", "w": [95.90, 96.03, 96.13] },
    { "at": 96.56, "line": "Who? Who?", "w": [96.56, 96.96] },
    { "at": 98.06, "line": "Who’s your bias?", "w": [98.06, 98.52, 98.62] },
    { "at": 99.00, "line": "I’m your bias!", "w": [99.00, 99.18, 99.32] },
    { "at": 99.64, "line": "Who’s your bias?", "w": [99.64, 99.94, 100.09] },
    { "at": 100.56, "line": "I’m your bias!", "w": [100.56, 100.69, 100.79] },
    { "at": 101.22, "line": "Who’s your bias?", "w": [101.22, 101.52, 101.67] },
    { "at": 102.14, "line": "I’m your bias!", "w": [102.14, 102.27, 102.37] },
    { "at": 103.72, "line": "It’s Me", "w": [103.72, 104.18] },

    { "at": 106.66, "line": "It’s Me", "w": [106.66, 107.36] },
    { "at": 108.96, "line": "Me", "w": [108.96] },
    { "at": 109.96, "line": "Me, Me!", "w": [109.96, 110.52] },
    { "at": 112.00, "line": "It’s Me", "w": [112.00, 112.60] },

    { "at": 130.10, "line": "Who’s your bias?", "w": [130.10, 130.54, 130.60] },
    { "at": 131.08, "line": "I’m your bias!", "w": [131.08, 131.20, 131.30] },
    { "at": 131.78, "line": "Who’s your bias?", "w": [131.78, 132.14, 132.20] },
    { "at": 132.66, "line": "I’m your bias!", "w": [132.66, 132.80, 132.94] },
    { "at": 133.90, "line": "It’s Me", "w": [133.90, 134.40] },
    { "at": 136.56, "line": "Who’s your bias?", "w": [136.56, 136.90, 136.96] },
    { "at": 137.44, "line": "I’m your bias!", "w": [137.44, 137.60, 137.70] },
    { "at": 138.24, "line": "Who’s your bias?", "w": [138.24, 138.50, 138.58] },
    { "at": 139.06, "line": "I’m your bias!", "w": [139.06, 139.22, 139.34] },
    { "at": 142.14, "line": "It’s Me", "w": [142.14, 142.54] },
    { "at": 144.48, "line": "Who’s your bias?", "w": [144.48, 144.92, 144.96] },
    { "at": 145.46, "line": "I’m your bias!", "w": [145.46, 145.60, 145.70] },
    { "at": 146.42, "line": "Who’s your bias?", "w": [146.42, 146.50, 146.56] },
    { "at": 147.02, "line": "I’m your bias!", "w": [147.02, 147.18, 147.32] },
    { "at": 148.52, "line": "It’s Me", "w": [148.52, 148.96] },
    { "at": 149.38, "line": "Who’s your bias?", "w": [149.38, 149.76, 149.80] },
    { "at": 150.28, "line": "I’m your bias!", "w": [150.28, 150.38, 150.50] },
    { "at": 152.00, "line": "Who’s your bias?", "w": [152.00, 152.50, 152.94] },
    { "at": 153.50, "line": "I’m your bias!", "w": [153.50, 153.60, 153.72] },
    { "at": 154.84, "line": "It’s Me", "w": [154.84, 155.36] }
  ]
};
